export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14851.44aa0239.jpg";